module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"config","commonjs2":"config","amd":"config","root":"config"}
// module id = 13
// module chunks = 0